import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseRequestHeaderSearch = () => {
  const warehouseRequestHeaderSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/request-header/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { warehouseRequestHeaderSearch }
}

export default InteractorWarehouseRequestHeaderSearch
